import * as React from "react";

import '../../css/components/Breadcrumbs.scss';

class Breadcrumb {
    key: string;
    label: string;
    url: string
}

export interface BreadcrumbProps { breadcrumbs: Breadcrumb[] }

export class Breadcrumbs extends React.Component<BreadcrumbProps, {}> {
    render() {
        return <nav className="navbar breadcrumbs">
            {
                this.props.breadcrumbs.map((breadcrumb: Breadcrumb) => {
                    let className = '';
                    if (breadcrumb.label === '/')
                        className = 'separator ';

                    if (breadcrumb.url)
                        return <div className={className + 'navbar-nav'} key={breadcrumb.key}>
                            <a className="nav-link" href={breadcrumb.url}>{breadcrumb.label}</a>
                        </div>
                    else {
                        return <span className={className + 'navbar-text'} key={breadcrumb.key}>{breadcrumb.label}</span>
                    }
                })
            }
        </nav>
    }
}
